import React, { useState, useEffect } from 'react'

// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import TimePicker from '@mui/lab/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Button, TextField } from '@mui/material';
import dayjs from 'dayjs';

// import frLocale from 'date-fns/locale/fr';
import heLocale from 'date-fns/locale/he';

import MyDateTime from '../../../../MySections/TimeSections/MyDateTime';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AddBoxOutlined, RemoveCircleOutline, RemoveCircleOutlineOutlined } from '@mui/icons-material';
// import Login from '../Login/Login';
// import useToken from '../Login/useToken';


const BlockedDateList = (props) => {
    const [dts, setDts] = useState(props.theDates);

    useEffect(() => {
        setDts(props.theDates);
    }, [props.theDates]);




    const updateDatsLst = (index, dateVal, remark) => {
        let tempLst = dts;
        tempLst[index].dateVal = dateVal;
        tempLst[index].Day = MyDateTime.getDayOfWeekHeb(dateVal);
        tempLst[index].remark = remark;
        setDts(tempLst)
        props.SetTheDates(tempLst);
    }

    const addDateToList = () => {
        let itm = {
            dateVal: new Date(),
            Day: MyDateTime.getDayOfWeekHeb(new Date()),
            remark: ""
        }
        let tempLst = [...dts];
        tempLst.push(itm)
        setDts(tempLst)
        props.SetTheDates(tempLst);
    }

    const removeDateFromList = (index) => {
        let tempLst = [...dts];
        tempLst.splice(index, 1);
        setDts(tempLst)
        props.SetTheDates(tempLst);
    }

    const updateDatsRemark = (index, dateVal, remark) => {
        // צור עותק חדש של המערך
        const tempLst = [...dts];
        // צור עותק חדש של האובייקט בעמודה index ועדכן אותו
        tempLst[index] = {
            ...tempLst[index],
            dateVal: dateVal,
            Day: MyDateTime.getDayOfWeekHeb(dateVal),
            remark: remark
        };
        setDts(tempLst);
        props.SetTheDates(tempLst);
    }
    return (
        <>
            <div className={"fullRow spaceMargeBottomnBig"}>
                <Button className={"btnSPc btnSPcSpec"} variant="contained" onClick={() => addDateToList()}
                    startIcon={<AddBoxOutlined style={{ color: 'white' }} />}>
                    הוסף תאריך
                </Button>
            </div>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={heLocale}>
                <table className={"tabTable tableBordSpace"}>
                    <tbody>
                        {
                            dts?.map((item, index) => {
                                return (
                                    <tr key={index} style={{ marginTop: "10px" }}>
                                        <td>
                                            <table className={"tblOpHours"}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <DatePicker
                                                                className="myClander"
                                                                label=""
                                                                value={new Date(item.dateVal)}
                                                                onChange={(newValue) => updateDatsLst(index, newValue, item.remark)}
                                                                inputFormat="dd/MM/yyyy"
                                                                mask="__/__/____"
                                                                renderInput={(params) => <TextField {...params} />}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </td>
                                        <td style={{ width: "20%" }} className={"centerText"}>{item.Day}</td>

                                        <td style={{ width: "40%" }} className={"centerText"}>
                                            <input type="text" className={"form-control"} placeholder={""}
                                                value={item.remark}
                                                onChange={(e) => { updateDatsRemark(index, item.dateVal, e.target.value) }}
                                            />

                                        </td>
                                        <td >
                                            <RemoveCircleOutlineOutlined className={"removeBtnMinus onRight"}
                                                onClick={() => removeDateFromList(index)} />
                                        </td>

                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

            </LocalizationProvider>
        </>
    )
}


export default BlockedDateList;
